import React from 'react';
import { useIntl } from 'react-intl';
import { LeftOutlined } from '@ant-design/icons';
import type { CategoryConfig, CategoryQuestionNode } from '../../../types/category';
import { usePageTheme } from './theme/usePageTheme';
import V2PageFrame from './components/V2PageFrame';
import V2Header from './components/V2Header';
import QuestionSelectBody from '../shared/QuestionSelectBody';

interface UCQuestionPageProps {
  categoryConfig: CategoryConfig;
  options: CategoryQuestionNode[];
  hideHeader?: boolean;
  onBack: () => void;
  onSelect: (node: CategoryQuestionNode) => void;
  onSelectOther: () => void;
}

const UCQuestionPage: React.FC<UCQuestionPageProps> = ({
  categoryConfig,
  options,
  hideHeader = false,
  onBack,
  onSelect,
  onSelectOther,
}) => {
  const intl = useIntl();
  const { tokens } = usePageTheme();

  return (
    <V2PageFrame
      header={
        hideHeader ? undefined : (
          <V2Header
            title={intl.formatMessage({
              id: 'v2.customer_support',
              defaultMessage: 'Customer Support',
            })}
            left={
              <button
                type="button"
                onClick={onBack}
                style={{
                  border: 'none',
                  background: 'transparent',
                  color: tokens.text,
                  cursor: 'pointer',
                  padding: 8,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <LeftOutlined style={{ fontSize: 18 }} />
              </button>
            }
          />
        )
      }
    >
      <div style={{ flex: 1, minHeight: 0, position: 'relative', paddingTop: hideHeader ? 36 : 0 }}>
        {hideHeader ? (
          <button
            type="button"
            onClick={onBack}
            aria-label={intl.formatMessage({
              id: 'v2.back',
              defaultMessage: 'Back',
            })}
            style={{
              position: 'absolute',
              top: 8,
              left: 8,
              zIndex: 20,
              border: 'none',
              background: 'transparent',
              color: tokens.text,
              cursor: 'pointer',
              padding: 8,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <LeftOutlined style={{ fontSize: 18 }} />
          </button>
        ) : null}
        <QuestionSelectBody
          categoryConfig={categoryConfig}
          options={options}
          vars={{
            cardBg: tokens.cardBg,
            text: tokens.text,
            textSecondary: tokens.textSecondary,
            border: tokens.border,
            accent: tokens.accent,
            hoverBg: tokens.hoverBg,
          }}
          onSelect={onSelect}
          onSelectOther={onSelectOther}
        />
      </div>
    </V2PageFrame>
  );
};

export default UCQuestionPage;
